/* SET STATE */
export const SET_STATE_LABREQUESTCALENDAR = "SET_STATE_LABREQUESTCALENDAR"

/* LABREQUESTCALENDARS */
export const GET_LABREQUESTCALENDARS = "GET_LABREQUESTCALENDARS"
export const GET_LABREQUESTCALENDARS_SUCCESS = "GET_LABREQUESTCALENDARS_SUCCESS"
export const GET_LABREQUESTCALENDARS_FAIL = "GET_LABREQUESTCALENDARS_FAIL"

/* LABREQUESTCALENDAR */
export const GET_LABREQUESTCALENDAR = "GET_LABREQUESTCALENDAR"
export const GET_LABREQUESTCALENDAR_SUCCESS = "GET_LABREQUESTCALENDAR_SUCCESS"
export const GET_LABREQUESTCALENDAR_FAIL = "GET_LABREQUESTCALENDAR_FAIL"

/**
 * ADD LABREQUESTCALENDAR
 */
 export const ADD_NEW_LABREQUESTCALENDAR = "ADD_NEW_LABREQUESTCALENDAR"
 export const ADD_LABREQUESTCALENDAR_SUCCESS = "ADD_LABREQUESTCALENDAR_SUCCESS"
 export const ADD_LABREQUESTCALENDAR_FAIL = "ADD_LABREQUESTCALENDAR_FAIL"

 /**
 * UPDATE LABREQUESTCALENDAR
 */
export const UPDATE_LABREQUESTCALENDAR = "UPDATE_LABREQUESTCALENDAR"
export const UPDATE_LABREQUESTCALENDAR_SUCCESS = "UPDATE_LABREQUESTCALENDAR_SUCCESS"
export const UPDATE_LABREQUESTCALENDAR_FAIL = "UPDATE_LABREQUESTCALENDAR_FAIL"

/**
 * DELETE LABREQUESTCALENDAR
 */
export const DELETE_LABREQUESTCALENDAR = "DELETE_LABREQUESTCALENDAR"
export const DELETE_LABREQUESTCALENDAR_SUCCESS = "DELETE_LABREQUESTCALENDAR_SUCCESS"
export const DELETE_LABREQUESTCALENDAR_FAIL = "DELETE_LABREQUESTCALENDAR_FAIL"
